import { Link } from "react-router-dom";

export default function FeaturesPreviewSection() {
  const features = [
    {
      icon: "ri-robot-2-line",
      title: "AI Content Engine",
      description: "GPT-4 powered content creation that analyzes your Skool group and generates platform-perfect posts, captions, and hashtags automatically.",
      color: "bg-violet-500",
      lightColor: "bg-violet-50",
      textColor: "text-violet-600",
    },
    {
      icon: "ri-calendar-2-line",
      title: "Smart Scheduler",
      description: "Set it and forget it. Our AI finds the best posting times for each network and publishes automatically — even while you sleep.",
      color: "bg-fuchsia-500",
      lightColor: "bg-fuchsia-50",
      textColor: "text-fuchsia-600",
    },
    {
      icon: "ri-share-forward-2-line",
      title: "30+ Sites and Networks Auto-Posting",
      description: "Reach everywhere at once. Post to social media, video platforms, blogs, and directory sites all from one dashboard.",
      color: "bg-emerald-500",
      lightColor: "bg-emerald-50",
      textColor: "text-emerald-600",
    },
    {
      icon: "ri-bar-chart-box-line",
      title: "Analytics Dashboard",
      description: "Track impressions, clicks, engagement, and new Skool members driven by each post across every network in real time.",
      color: "bg-amber-500",
      lightColor: "bg-amber-50",
      textColor: "text-amber-600",
    },
    {
      icon: "ri-links-line",
      title: "Skool Integration",
      description: "Deep integration with Skool.com. Analyze group content, track member growth, and attribute new joins to specific marketing campaigns.",
      color: "bg-sky-500",
      lightColor: "bg-sky-50",
      textColor: "text-sky-600",
    },
    {
      icon: "ri-shield-check-line",
      title: "Plan-Based Access",
      description: "Flexible plans that unlock more networks, AI credits, and scheduling slots as your community grows. Upgrade anytime.",
      color: "bg-rose-500",
      lightColor: "bg-rose-50",
      textColor: "text-rose-600",
    },
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full bg-violet-100 text-violet-700 text-xs font-semibold uppercase tracking-wider mb-4">
            Platform Features
          </span>
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-4">
            Everything You Need to{" "}
            <span className="bg-gradient-to-r from-violet-600 to-fuchsia-500 bg-clip-text text-transparent">
              Grow Your Skool Group
            </span>
          </h2>
          <p className="text-lg text-gray-500 max-w-2xl mx-auto">
            One platform. All the tools. Zero marketing expertise required.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="group p-6 rounded-2xl border border-gray-100 hover:border-violet-200 bg-white hover:bg-violet-50/30 transition-all duration-300 cursor-pointer"
            >
              <div className={`w-12 h-12 flex items-center justify-center rounded-xl ${feature.lightColor} mb-5`}>
                <i className={`${feature.icon} text-xl ${feature.textColor}`}></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">{feature.title}</h3>
              <p className="text-sm text-gray-500 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>

        <div className="text-center">
          <Link
            to="/features"
            className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full border-2 border-violet-600 text-violet-600 font-semibold hover:bg-violet-600 hover:text-white transition-all whitespace-nowrap cursor-pointer"
          >
            Explore All Features <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}
